import * as React from 'react';

import { cn } from '../../utils/cn';

export function Pagination({
    className,
    ...props
}: React.ComponentProps<'nav'>) {
    return (
        <nav
            role="navigation"
            aria-label="pagination"
            data-slot="pagination"
            className={cn('mx-auto flex w-full justify-center', className)}
            {...props}
        />
    );
}
